import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    maxWidth: 396,
    margin: '50px auto',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(0, 1),
  },
}));

export default useStyles;
